export default function initAccessibility() {

    if (typeof MutationObserver !== 'undefined') {
        // TODO Watch for new links
    }

    const loc = window.location;
    const domain = loc.host.replace(/^www\./, '');
    const externalRegExp = /^(https?:)?\/\//;
    const domainRegExp = new RegExp(`^(https?:)?//(www\.)?${domain}[/?#]?`, 'i');
    const wysiwygDepth = 5;

    processContent(document.body);

    /**
     * @param {HTMLElement} root
     */
    function processContent(root) {
        [].slice.apply(document.querySelectorAll('a')).forEach(a => {
            if (a.href && a.href.length > 1) {
                const isExternal = externalRegExp.test(a.href) && !domainRegExp.test(a.href);

                if (isExternal) {
                    a.target = '_blank';
                    if (a.classList.contains('is--inline') || a.classList.contains('lbrl-btn') || isWithinWysiwygContent(a)) {
                        const iconSpan = document.createElement('span');
                        iconSpan.classList.add('externalIcon');
                        a.appendChild(iconSpan);
                    }
                }
            }
        });
    }

    function isWithinWysiwygContent(el) {
        let parent = el.parentElement;
        for (let i = 0; i < wysiwygDepth; i++) {
            if (!parent) {
                return;
            } else if (parent.classList.contains('wysiwyg-content')) {
                return true;
            }
            parent = parent.parentElement;
        }
    }
}
